import axios from "axios";
import router from '@/router/index';
import store from "@/store";
import AuthenService from "@/services/authen-service/AuthenService";
export default () => {
    const user = store.state.code;
    const api = axios.create({
        headers: {Authorization : 'Bearer ' + user.accessToken},
        baseURL : process.env.VUE_APP_URL_IDENTITY_SERVICE_API_JWT
    });
    api.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        const originalConfig = err.config;
        if (originalConfig.url !== "/login" && err.response) {
          if (err.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;
            try {
                /* refresh token */
                const refreshResponse = await new AuthenService().refreshToken(user.refreshToken);
                store.commit('UpdateCode', {
                  accessToken: refreshResponse.data.access_token,
                  refreshToken: refreshResponse.data.refresh_token
                });
                 /* refresh token */
              err.config.headers[
                "Authorization"
              ] = `Bearer ${refreshResponse.data.access_token}`;
              return new Promise((resolve, reject) => {
                axios.request(originalConfig).then(response => {
                  resolve(response);
                }).catch((err) => {
                  store.commit('logOut')
                  router.push({ name: "login" });
                  reject(err);
                })
              });
            } catch (_error) {
         
              return Promise.reject(_error);
            }
          }
        }
 
        const url = new URL(location.href);
        store.commit('logOut');
        new AuthenService().logoutOauth2(url.origin + '/expresswifiportal/login');
        return Promise.reject(err);
      }
    );
    return api;
}
